module.exports = __webpack_public_path__ + "public/img/SQ@2x.cb6bba45.png";